<template>
  <div style="position: absolute;" v-bind:class="{ 'overflow-hidden': !disabled }" v-bind:style="parent">
    <div style="position: absolute;" v-bind:style="child">
      <slot></slot>
    </div>
  </div>
</template>


<script>
function invertCropPct(pct, oppositePct) {
  // The crop values are expressed as percentages of the original bounds to remove. We absolutely positon the visual
  // media element within a masking (overflow-hidden) div, so we need to invert these percentages to express them in
  // terms of the masking div.
  return `${-100 * pct / (1 - pct - oppositePct)}%`;
}

export default {
  name: 'crop-media',

  // This component can work with a minimal media element that just optionally has the 'crop' property set, though it
  // won't take rotation into account
  props: [ 'media', 'size', 'disabled' ],

  data() {
    return {
      parent: {},
      child: {}
    }
  },

  methods: {
    getParentStyle() {
      const style = { width: '100%', height: '100%' };
      if (this.disabled)
        return style;
      if (this.media.letterbox)
        style.backgroundColor = '#000';
      if (this.media.r) {
        // This media element has intrinsic rotation (outside of any automations)
        style.transform = `rotate(${this.media.r}deg)`;
        if (this.media.r % 180 != 0) {
          style.width = `${this.size.h}px`;
          style.height = `${this.size.w}px`;
        }
      }
      return style;
    },

    getChildStyle() {
      const c = this.media.crop;
      if (this.disabled || !c)
        return { top: 0, right: 0, bottom: 0, left: 0 };
      return {
        top: invertCropPct(c.top, c.bottom),
        right: invertCropPct(c.right, c.left),
        bottom: invertCropPct(c.bottom, c.top),
        left: invertCropPct(c.left, c.right)
      };
    }
  },

  watch: {
    media: {
      immediate: true,
      deep: true,
      handler() {
        this.parent = this.getParentStyle();
        this.child = this.getChildStyle();
      }
    },

    size: {
      deep: true,
      handler() {
        this.parent = this.getParentStyle();
      }
    }
  }
}
</script>
